module.exports = __webpack_public_path__ + "static/media/3-VORR.a87f5f3d.mp3";